// Convite pendente: quem abre o link do convite antes de entrar na conta continua o caminho depois do login.
import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE = 'convite_pendente';
/** Tira o código de um link (https://myplanner.expo.app/convite?c=XXXX ou myplanner://convite?c=XXXX). */
export function codigoDoLink(url: string | null | undefined): string | null {
  if (!url || !/convite/i.test(url)) return null;
  const m = url.match(/[?&]c=([A-Za-z0-9]{6,12})/);
  return m ? m[1].toUpperCase() : null;
}
export const guardarConvite = (c: string) => AsyncStorage.setItem(CHAVE, c).catch(() => {});
export const pegarConvite = () => AsyncStorage.getItem(CHAVE).catch(() => null);
export const limparConvite = () => AsyncStorage.removeItem(CHAVE).catch(() => {});
